import { render } from "./EditUnitProfile.vue?vue&type=template&id=4e8e872a"
import script from "./EditUnitProfile.vue?vue&type=script&lang=js"
export * from "./EditUnitProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__